import { COLLECTION_KEY } from "./shared.ts";

export const removeStickyStateByPrefix = (prefix: string) => {
  const values = localStorage.getItem(COLLECTION_KEY);
  if (values) {
    const records = JSON.parse(values);
    for (const key in records) {
      if (key.startsWith(prefix)) {
        delete records[key];
      }
    }
    localStorage.setItem(COLLECTION_KEY, JSON.stringify(records));
  }
};
